


































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  get snippet1 () {
    return `copy() {
  let yourCopyText = "Whatever you need to copy goes here";
  let tempInput = document.createElement("input");
  tempInput.style.position = "absolute";
  tempInput.style.left = "-1000px";
  tempInput.style.top = "-1000px";
  tempInput.value = yourCopyTextHere;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  alert("Success! Your text has been copied!");
}`
  }

  get snippet2 () {
    return `copyUrlToClipboard() {
  const currentUrl = window.location.href;
  let tempInput = document.createElement("input");
  tempInput.style.position = "absolute";
  tempInput.style.left = "-1000px";
  tempInput.style.top = "-1000px";
  tempInput.value = currentUrl;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  alert("Current URL copied to clipboard.");
}`
  }

  get snippet3 () {
    return `<html>
  <body>
    <p>Your code is <span id="copyable">3432</span>.</p>
  </body>
</html>`
  }

  get snippet4 () {
    return `copySpanToClipboard() {
  const copyableSpan = document.getElementById('copyable');
  let tempInput = document.createElement("input");
  tempInput.style.position = "absolute";
  tempInput.style.left = "-1000px";
  tempInput.style.top = "-1000px";
  tempInput.value = copyableSpan.value; // Use the value property
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  alert("Your code has been copied!");
}`
  }
}
